import React from "react";
import { Box, CircularProgress, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "calc(100vh - 64px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.background.default,
  },
  content: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: 999,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme?.neoUI?.effects?.glow?.main || "0 4px 16px rgba(0,0,0,0.08)",
  },
  text: {
    fontSize: "0.875rem",
    color: theme.palette.text.secondary,
  },
}));

const RouteTransitionFallback = ({ label = "Preparando página..." }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root} data-mobile-page-transition>
      <Box className={classes.content}>
        <CircularProgress size={18} thickness={5} />
        <Typography className={classes.text}>{label}</Typography>
      </Box>
    </Box>
  );
};

export default RouteTransitionFallback;
